import React from 'react';
import { TopBar } from '../components/TopBar';
import { WebinarHero } from '../components/WebinarHero';
import { WhatYouLearn } from '../components/WhatYouLearn';
import { SocialProof } from '../components/SocialProof';
import { WebinarFooter } from '../components/WebinarFooter';
import { motion } from 'framer-motion';
import { LeadCaptureForm } from '../components/LeadCaptureForm';
export function WebinarPage() {
  return <div style={{
    background: 'var(--bg-deep)',
    minHeight: '100vh',
    width: '100%'
  }} data-id="element-314">
      <TopBar data-id="element-315" />
      <main data-id="element-316">
        <WebinarHero data-id="element-317" />
      </main>
      <WebinarFooter data-id="element-318" />
    </div>;
}